
import { Vue, Component } from "vue-property-decorator";
import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component
export default class Tickets extends Vue {
  grid = {};
  url = "/api/fuelpump/grid?_search=true&rows=20";
  showFilter = true;
  name = "";
  menu1 = false;
  filterUrl = "";
  country = "";
  city = "";
  zone = "";
  page = 1;

  get loading() {
    return common.loading;
  }

  async mounted() {
    try {
      this.grid = await doGet(this.url);
    } catch (e) {
      common.setError(e.message);
    }
  }

  async deleteShift(pump) {
    common.setLoading(true);
    try {
      await doGet("/api/fuelpump/" + pump._id + "/delete");
      common.showMessage("Deleted Successfully");
      await this.search();
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  async showPage(page) {
    this.page = page;
    this.grid = await doGet(this.url + this.filterUrl + "&page=" + page);
    common.setLoading(false);
  }

  async clear() {
    this.name = "";
    this.country = "";
    this.city = "";
    this.page = 1;
    this.search();
  }

  async search() {
    this.filterUrl = "";
    if (this.name) this.filterUrl += "&name=" + this.name;
    if (this.country) this.filterUrl += "&address.country=" + this.country;
    if (this.city) this.filterUrl += "&address.city=" + this.city;
    common.setLoading(true);
    await this.showPage(1);
  }
}
